import { appContext } from '../../../app.context';
import { AppConstants } from '../../../app.constants';

export const CalendarComponent = {
    template: require('./calendar-component.html'),
    controller: class CalendarComponent {

        private options: any;

        private dateValue: Date;
        private dateFormat: string;

        private isOpened: boolean;

        private model: any;
        private name: string;
        private onChange: Function;

        constructor(
        ) {
            this.options = {
            };
            this.dateFormat = AppConstants.dateFormat;
        }

        $onInit(): void {
            if (this.model !== '') {
                this.dateValue = new Date(this.model);
            }
        }

        change(): void {
            this.onChange({
                field: this.name,
                value: this.dateValue
            });
        }

        openDP($event: any) {
            $event.preventDefault();
            $event.stopPropagation();
            this.isOpened = true;
        }

        autoOpen($event: any) {
            if (appContext.userBrowser.isIE) {
                return;
            }

            $event.preventDefault();
            $event.stopPropagation();
            this.isOpened = true;
        }
    },
    bindings: {
        label: '@',
        name: '@',
        model: '<',
        isRequired: '<',
        onChange: '&'
    },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/calendar/calendar-component.ts